import { render } from "./BLoader.vue?vue&type=template&id=19cedeb8&ts=true"
import script from "./BLoader.vue?vue&type=script&lang=ts"
export * from "./BLoader.vue?vue&type=script&lang=ts"

import "./BLoader.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/vav/Dev/eco-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__